import {createSelector} from 'reselect';
import {compose, getFrom} from '@pluto/utils';
import {TargetAgeState} from '../TargetAgeTypes';

interface State {
    targetAge: TargetAgeState
}

const selectSelf = (state: State) => state;

export const selectTargetAge = createSelector(
    selectSelf,
    getFrom('targetAge')
);

export const selectContentItemTerritorial = createSelector(
    getFrom('qcToolsStore'),
    compose(getFrom('territorial'), getFrom('qcToolsStore')),
);
